var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.351 3.35917L1.3468 14.3642C1.29139 14.4198 1.25189 14.4892 1.23244 14.5652L0.0126888 19.4609C-0.00525068 19.5336 -0.00415128 19.6096 0.0158808 19.6817C0.0359129 19.7538 0.0742006 19.8196 0.127046 19.8725C0.208215 19.9534 0.318116 19.9989 0.432715 19.999C0.468068 19.999 0.503284 19.9946 0.537569 19.986L5.43327 18.7661C5.5094 18.747 5.57888 18.7075 5.63429 18.6519L16.6395 7.6476L12.351 3.35917ZM19.3657 1.85864L18.1408 0.633734C17.3221 -0.184958 15.8952 -0.184146 15.0774 0.633734L13.5769 2.13426L17.8652 6.42253L19.3657 4.92204C19.7747 4.51326 19.9999 3.96913 19.9999 3.39044C19.9999 2.81175 19.7747 2.26763 19.3657 1.85864Z",
    fill: "#00D34F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.d16c8d03eac865f8ebdec40bd4038a23.svg";
export { ForwardRef as ReactComponent };